import { useRef, useState } from 'react';

export const useTimeoutCheckpoints = (checkpoints = []) => {
  const [currentCheckpoint, setCheckpoint] = useState(undefined);
  const timeoutRefs = useRef([]);

  const startCounters = () => {
    timeoutRefs.current = checkpoints.map((checkpoint, index) => {
      return setTimeout(() => {
        setCheckpoint(index);
      }, checkpoint);
    });
  };

  const stopCounters = () => {
    timeoutRefs.current.forEach((ref) => {
      clearTimeout(ref);
    });
  };

  return { currentCheckpoint, startCounters, stopCounters };
};
